import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { useCallback, useState, useEffect } from 'react';
import { AnalyticsListener as AKAnalyticsListener } from '@atlaskit/analytics-next';
import { getAnalyticsWebClient } from './analyticsWebClient';
export var ANALYTICS_CHANNEL = 'embeddedConfluence';
var packageName = "@atlassian/embedded-confluence";
var packageVersion = "11.7.0";
var AnalyticsListener = function AnalyticsListener(_ref) {
  var children = _ref.children,
    hostname = _ref.hostname,
    parentProduct = _ref.parentProduct,
    userInfo = _ref.userInfo;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    analyticsClient = _useState2[0],
    setAnalyticsClient = _useState2[1];
  useEffect(function () {
    getAnalyticsWebClient({
      hostname: hostname,
      userInfo: userInfo
    }).then(function (res) {
      setAnalyticsClient(res);
    });
  }, [hostname, userInfo]);
  var onEvent = useCallback(function (_ref2) {
    var _analyticsClient$onEv;
    var payload = _ref2.payload;
    analyticsClient === null || analyticsClient === void 0 ? void 0 : (_analyticsClient$onEv = analyticsClient.onEvent) === null || _analyticsClient$onEv === void 0 ? void 0 : _analyticsClient$onEv.call(analyticsClient, ANALYTICS_CHANNEL, _objectSpread(_objectSpread({}, payload), {}, {
      attributes: _objectSpread(_objectSpread({}, payload === null || payload === void 0 ? void 0 : payload.attributes), {}, {
        packageName: packageName,
        packageVersion: packageVersion,
        parentProduct: parentProduct
      })
    }));
  }, [analyticsClient, parentProduct]);
  return analyticsClient ? /*#__PURE__*/React.createElement(AKAnalyticsListener, {
    channel: ANALYTICS_CHANNEL,
    onEvent: onEvent
  }, children) : null;
};
export var withAnalyticsListener = function withAnalyticsListener(WrappedComponent) {
  return function (props) {
    return /*#__PURE__*/React.createElement(AnalyticsListener, {
      hostname: props.hostname,
      parentProduct: props.parentProduct,
      userInfo: props.userInfo
    }, /*#__PURE__*/React.createElement(WrappedComponent, props));
  };
};